import {DEFAULT_PRESET_COLOR, NEUTRAL_PRESET_COLOR} from '../constants/presetColors';
import {resolvePresetColor} from './resolvePresetColor';

const NEUTRAL_COLOR_CLASSES = '[--preset-color:#172B4D] [--preset-background:#F4F5F7]';

// Literal classes ensure Tailwind includes every palette entry in the bundle.
const PRESET_COLOR_CLASSES = new Map<string, string>([
  [DEFAULT_PRESET_COLOR, NEUTRAL_COLOR_CLASSES],
  [NEUTRAL_PRESET_COLOR, NEUTRAL_COLOR_CLASSES],
  ['#0065FF', '[--preset-color:#0065FF] [--preset-background:#DCEFFF]'],
  ['#E32C1E', '[--preset-color:#E32C1E] [--preset-background:#FFEBE6]'],
  ['#24A148', '[--preset-color:#24A148] [--preset-background:#DEFBE6]'],
  ['#00B1D0', '[--preset-color:#00B1D0] [--preset-background:#E6FCFF]'],
  ['#6554C0', '[--preset-color:#6554C0] [--preset-background:#F0EDFF]'],
  ['#EE5396', '[--preset-color:#EE5396] [--preset-background:#FCF1F7]'],
  ['#FFD600', '[--preset-color:#FFD600] [--preset-background:#FFF9C4]'],
  ['#FF9800', '[--preset-color:#FF9800] [--preset-background:#FFF3E0]'],
]);

const SURFACE_CLASSES = 'border-transparent hover:brightness-95';

export function getPresetColorClasses(color: string | undefined, active: boolean) {
  const resolvedColor = resolvePresetColor(color);
  const palette = PRESET_COLOR_CLASSES.get(resolvedColor) ?? NEUTRAL_COLOR_CLASSES;
  const textColor = resolvedColor === DEFAULT_PRESET_COLOR ? 'text-[#2E384B]' : 'text-[#392D5B]';
  const state = active
    ? 'bg-[var(--preset-color)] text-white'
    : `bg-[var(--preset-background)] ${textColor}`;
  const countOpacity =
    resolvedColor === DEFAULT_PRESET_COLOR && !active
      ? '[--preset-count-opacity:0.8]'
      : '[--preset-count-opacity:0.7]';

  return `${palette} ${SURFACE_CLASSES} ${state} ${countOpacity}`;
}
